import React from 'react';
import './ProductsOverview.css';

const scrollToFeatures = () => {
  document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
};

const ProductsOverview = ({ onProductChange, onContactClick }) => {
  const products = [
    {
      id: 'core',
      name: 'Neoshift Core',
      badge: 'New',
      icon: '🏢',
      description:
        'AI-native back office for distributors and wholesalers — master data, pricing, sales, procurement, warehouse, and invoicing in one workspace.',
      primaryCta: { label: 'Launch Neoshift Core', href: 'https://core.neoshift.ai', external: true },
      secondaryCta: {
        label: 'Explore features',
        action: () => {
          onProductChange('core');
          scrollToFeatures();
        }
      },
      featured: true
    },
    {
      id: 'etl',
      name: 'Neoshift ETL',
      icon: '⚡',
      description:
        'AI that reads, validates, and syncs documents into your ERP, CRM, and WMS — replacing hours of manual data entry.',
      primaryCta: {
        label: 'Explore ETL',
        action: () => {
          onProductChange('etl');
          scrollToFeatures();
        }
      },
      secondaryCta: { label: 'Get a Free POC', action: onContactClick }
    },
    {
      id: 'bi',
      name: 'Neoshift BI',
      icon: '📊',
      description:
        'Ask questions in plain English and get instant insights, dashboards, and forecasts — no SQL required.',
      primaryCta: { label: 'Launch Neoshift BI', href: 'https://bi.neoshift.ai', external: true },
      secondaryCta: {
        label: 'Explore BI',
        action: () => {
          onProductChange('bi');
          scrollToFeatures();
        }
      }
    }
  ];

  const handleCta = (cta) => {
    if (cta.action) {
      cta.action();
    }
  };

  return (
    <section id="products" className="products-overview">
      <div className="products-overview-container">
        <div className="products-overview-header">
          <h2 className="products-overview-title">The Neoshift Platform</h2>
          <p className="products-overview-subtitle">
            From day-to-day operations to document automation and analytics — choose the product that fits your team, or use them together.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <article
              key={product.id}
              className={`product-card ${product.featured ? 'product-card-featured' : ''}`}
            >
              {product.badge && <span className="product-badge">{product.badge}</span>}
              <div className="product-icon">{product.icon}</div>
              <h3 className="product-name">{product.name}</h3>
              <p className="product-description">{product.description}</p>
              <div className="product-actions">
                {product.primaryCta.external ? (
                  <a
                    href={product.primaryCta.href}
                    className="product-cta primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {product.primaryCta.label}
                  </a>
                ) : (
                  <button
                    type="button"
                    className="product-cta primary"
                    onClick={() => handleCta(product.primaryCta)}
                  >
                    {product.primaryCta.label}
                  </button>
                )}
                {product.secondaryCta.external ? (
                  <a
                    href={product.secondaryCta.href}
                    className="product-cta secondary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {product.secondaryCta.label}
                  </a>
                ) : (
                  <button
                    type="button"
                    className="product-cta secondary"
                    onClick={() => handleCta(product.secondaryCta)}
                  >
                    {product.secondaryCta.label}
                  </button>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsOverview;
